<template>
    <tr :class="colorClass" v-if="customer">
        <td style="width:80px">
            <span :class="badgeClass" v-if="row.isAssessmentCompleted">{{Math.round(row.reportOverallScore)}}%</span>
        </td>
        <td class="cell-detail">
            <span>{{customer.name}}</span>
            <a :href="customer.website" target="_blank" class="cell-detail-description">{{customer.readableWebsite}}</a>
        </td>
        <td v-if="hasSectors">
            <span>{{sector ? sector.title : '–'}}</span>
        </td>
        <td class="cell-detail">
            <span>{{customer.street}}</span>
            <span>{{customer.country}} - {{customer.postcode}} {{customer.location}}</span>
        </td>
        <td class="cell-detail">
            <span>{{row.readableCreatedAt}}</span>
        </td>
        <td class="text-right">
            <div class="btn-group">
                <router-link class="btn btn-secondary" title="Assessment öffnen" :to="{ name: 'assessment', params: { id: row.id } }"><i class="icon mdi mdi-arrow-forward"></i></router-link>
                <button class="btn btn-danger" :title="deleteTitle" @click="$emit('remove', row)" :disabled="row.isReportCompleted"><i class="icon mdi mdi-delete"></i></button>
            </div>
        </td>
    </tr>
</template>

<script>
    import errorHandler from '../../../../mixins/errorHandler';
    import Sectors from '../../../../data/Sectors';
    import Assessment from '../../../../models/Assessment';

    export default {
        mixins: [errorHandler],

        props: {
            row: {
                type: Assessment,
                required: true,
            },
        },

        computed: {
            colorClass() {
                if (this.row.stateLead) {
                    return 'primary';
                }

                if (this.row.stateAssessment) {
                    return 'danger';
                }

                if (this.row.stateReport) {
                    return 'warning';
                }

                if (this.row.stateArchived) {
                    return 'success';
                }

                return '';
            },

            badgeClass: vm => ({
                badge: true,
                'px-2 py-1': true,
                'badge-success': vm.row.reportOverallScore >= 80,
                'badge-warning': (vm.row.reportOverallScore >= 50 && vm.row.reportOverallScore < 80),
                'badge-danger': vm.row.reportOverallScore < 50,
            }),

            deleteTitle: vm => (vm.row.isReportCompleted ? 'Archivierte Assessments können nicht entfernt werden' : 'Assessment löschen'),
        },

        asyncComputed: {
            customer: async vm => vm.row.getCustomer(),
            hasSectors: () => Sectors.hasSectors(),
            sector: async vm => vm.row.getSector(),
        },
    };
</script>
